/**
 * RIDAA Facets & Collection Filtering
 * Uses Shopify Section Rendering API for smooth catalog filtering and sorting
 */

class RidaaFacets {
  constructor() {
    this.form = document.querySelector('[data-facet-form]');
    if (!this.form) return;

    this.gridContainer = document.querySelector('[data-product-grid-container]');
    this.init();
  }

  init() {
    this.form.addEventListener('input', this.debounce(() => {
      this.applyFilters();
    }, 300));

    this.form.addEventListener('change', () => {
      this.applyFilters();
    });

    // Reset filters
    document.querySelectorAll('[data-facet-reset]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.resetFilters(btn.dataset.facetResetUrl);
      });
    });
  }

  async applyFilters() {
    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData).toString();
    const targetUrl = `${window.location.pathname}?${searchParams}`;

    if (this.gridContainer) {
      this.gridContainer.style.opacity = '0.5';
    }

    try {
      // Use Section Rendering API to fetch the updated grid
      const sectionId = this.gridContainer ? this.gridContainer.dataset.sectionId : '';
      const fetchUrl = sectionId ? `${targetUrl}&section_id=${sectionId}` : targetUrl;
      const res = await fetch(fetchUrl);
      const text = await res.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');

      const newGrid = doc.querySelector('[data-product-grid-container]');
      if (newGrid && this.gridContainer) {
        this.gridContainer.innerHTML = newGrid.innerHTML;
        this.gridContainer.style.opacity = '1';
      }

      window.history.pushState({ path: targetUrl }, '', targetUrl);
    } catch (err) {
      console.error('Filter error, falling back to reload', err);
      window.location.href = targetUrl;
    }
  }

  resetFilters(url) {
    if (url) {
      window.location.href = url;
    } else {
      this.form.reset();
      this.applyFilters();
    }
  }

  debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.Ridaa = window.Ridaa || {};
  window.Ridaa.facets = new RidaaFacets();
});
